/* eslint-disable */

import React, { useState, useEffect, useRef, useMemo } from "react";
import { venueStayData } from "../../data/venueStayData";
import { FilterColor } from "../../svgs";
import VenueStayDetailComponent from "./VenueStayDetails";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import axios from "axios";
import { MdChevronRight } from "react-icons/md";
import Map from "../map/MapHotel";
import SliderDetailVenueStayTab from "./SliderDetailVenueStayTab";
import { base_URL } from "../../config/config";
import { useSearchParams } from "react-router-dom";
import { deepClean } from "../../utils/utilityFunctions";
import BulkEnquiry from "./BulkEnquiry";
import Modal from "../shared/Modal";
import BulkEnquiryModal from "../myFav/BulkEnquiryModal";
import { useDispatch, useSelector } from "react-redux";
import {
	closeBulkEnquiry,
	openBulkEnquiry,
	setBulkEnquiryModal,
	setEnquiryType,
} from "../../store/features/bulkEnquirySlice";

const fetchHotels = async (page, sort, filters) => {
	try {
		// Clean filters to remove empty values before sending to API
		const cleanedFilters = deepClean(filters || {});

		const { data } = await axios.get(`${base_URL}/api/hotels/get`, {
			params: {
				page,
				limit: 24,
				sort,
				...cleanedFilters,
			},
		});
		return data;
	} catch (error) {
		console.error("Error fetching hotels:", error);
		return { hotels: [], total: 0 }; // Return default value on error
	}
};

const fetchHotelsData = async (page, sort, filters) => {
	const hotelsData = await fetchHotels(page, sort, filters);
	const hotelsList = hotelsData.hotels || [];

	return {
		hotels: [...hotelsList],
		total: hotelsData.total || 0,
		totalPages: hotelsData.totalPages || 0,
	};
};

const sortOptions = [
	{
		name: "Price Per Room",
		options: ["Low to High", "High to Low"],
	},
	{
		name: "Offers Availability",
	},
	{
		name: "Newest",
	},
	{ name: "Popularity (Most Viewed)" },
	// "Customer Ratings",
];

const VenuStayTab = ({
	filters,
	isShowMap,
	setIsShowMap,
	city,
	setCount,
	count,
	totalHotels = "0",
	breadcrumbPath = [],
}) => {
	const [filterVenues, setFilterVenues] = useState([]);
	const [mapBounds, setMapBounds] = useState(null);
	const [page, setPage] = useState(venueStayData.currentPage);
	const [totalVenues, setTotalVenues] = useState(0);
	const [venues, setVenues] = useState([]);
	const [isMobileView, setIsMobileView] = useState(false);
	const [showSort, setShowSort] = useState(false);
	const [sortType, setSortType] = useState("default");
	const [showSubSort, setShowSubSort] = useState("");
	const [sortSubType, setSortSubType] = useState("default");
	const [sortValue, setSortValue] = useState("");
	const [totalPages, setTotalPages] = useState(0);
	const [searchParams, setSearchParams] = useSearchParams();
	const dispatch = useDispatch();
	const bulkEnquiry = useSelector((state) => state.bulkEnquiry);

	const filterKey = useMemo(() => JSON.stringify(filters), [filters]);

	// console.log("VenuStayTab rendered with filters:", filters);

	const { data, isLoading, error, refetch, isFetching, isPlaceholderData } = useQuery({
		queryKey: ["hotels", page, sortValue, filterKey],
		queryFn: () => fetchHotelsData(page, sortValue, filters),
		placeholderData: keepPreviousData,
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	});
	const pageRequestedRef = useRef(1);
	const loadMoreRef = useRef(null);

	useEffect(() => {
		dispatch(closeBulkEnquiry());
	}, []);

	useEffect(() => {
		pageRequestedRef.current = 1;
		setPage(1);
		setVenues([]);
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, [filterKey]);

	// useEffect(() => {
	// 	if (data && pa) {
	// 		console.log("TOTAL HOOOTELS:", data.total);
	// 		// console.log("Data:", data.hotels);
	// 		// This useEffect could be unnecessary if you are already updating in onSuccess
	// 		setTotalVenues(data.total);
	// 		setCount(data.total);
	// 		setVenues(data.hotels);
	// 		setTotalPages(data.totalPages);
	// 	}
	// }, [data]);

	useEffect(() => {
		if (!data || isPlaceholderData) return;
		setTotalVenues(data.total);
		setCount(data.total);
		setTotalPages(data.totalPages);
		pageRequestedRef.current = page;

		setVenues((prev) => {
			if (page === 1) return data.hotels || [];
			const merged = [...prev, ...(data.hotels || [])];
			return merged.filter(
				(v, i, self) => i === self.findIndex((x) => x._id === v._id)
			);
		});
	}, [data, page, isPlaceholderData]);

	useEffect(() => {
		if (mapBounds && venues.length > 0) {
			const visibleVenues = venues.filter((venue) => {
				const lat = venue.overview.locationDetails.lat;
				const lng = venue.overview.locationDetails.lng;

				return (
					lat >= mapBounds.south &&
					lat <= mapBounds.north &&
					lng >= mapBounds.west &&
					lng <= mapBounds.east
				);
			});
			if (JSON.stringify(visibleVenues) !== JSON.stringify(venues)) {
				// console.log("Visible Venues:", visibleVenues);
				setFilterVenues(visibleVenues);
			}
		}
	}, [mapBounds, venues]);
	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth < 1024); // lg breakpoint in Tailwind
		};

		window.addEventListener("resize", handleResize);

		handleResize(); // Set initial value

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	// Infinite scroll: load next page when sentinel enters viewport
	useEffect(() => {
		const el = loadMoreRef.current;
		if (!el) return;
		const obs = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting && !isFetching && totalPages > page && pageRequestedRef.current === page) {
					pageRequestedRef.current = page + 1;
					setPage((prev) => prev + 1);
				}
			},
			{ rootMargin: "300px" }
		);
		obs.observe(el);
		return () => obs.disconnect();
	}, [isFetching, page, totalPages]);

	const handleSort = (type) => {
		setSortType(type);
		if (
			type === "Offers Availability" ||
			type === "Newest" ||
			type === "Popularity (Most Viewed)"
		) {
			if (type === "Offers Availability") {
				setSortValue("Offers");
			} else if (type === "Newest") {
				setSortValue("Newest");
			} else if (type === "Popularity (Most Viewed)") {
				setSortValue("Popular");
			}
			setShowSort(false);
		}
		if (type === "Price Per Room") {
			setShowSubSort("pricePerRoom");
		} else {
			return;
		}
	};
	const handleSubSort = (type) => {
		if (type === "Low to High") {
			setSortValue("PriceLow");
		} else if (type === "High to Low") {
			setSortValue("PriceHigh");
		}
		setSortSubType(type);
		setShowSubSort("");
		setShowSort(false);
	};

	// useEffect(() => {
	// 	setCount(totalVenues);
	// }, [totalVenues]);
	// useEffect(() => {
	// 	if (isShowMap) {
	// 		setCount(filterVenues.length);
	// 	} else {
	// 		setCount(venues.length || 0);
	// 	}
	// }, [venues, isShowMap, filterVenues]);

	if (isLoading && venues.length === 0)
		return (
			<div className="grid w-full lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6">
				{Array.from({ length: 6 }).map((_, i) => (
					<div key={i} className="rounded-xl animate-pulse bg-gray-100 h-[480px]" />
				))}
			</div>
		);
	if (error) return <p>Error loading venues</p>;

	return (
		<div className="relative w-full">
			<div className="flex flex-col gap-4">
				<div className="flex w-full justify-between sm:flex-row flex-col font-medium sm:items-center">
					<h1 className="text-lg">
						{/* {isShowMap && filterVenues?.length
							? `${filterVenues?.length} `
							: `${totalVenues || count.venue} `} */}
						{totalHotels} venues in {filters.city || "All Cities"}
					</h1>
					<div className="flex items-center justify-end gap-6">
						<div className="flex items-center gap-2 relative">
							<button
								className="text-primary font-medium px-5 py-2 rounded-xl shadow-lg hover:shadow-lg transition-all duration-300 ease-in-out"
								onClick={() => {
									dispatch(openBulkEnquiry());
									dispatch(setEnquiryType("hotel"));
								}}
							>
								Bulk Enquiry
							</button>

							<div
								className="flex items-center gap-2 cursor-pointer"
								onClick={() => {
									setShowSort(!showSort);
									setSortType("default");
								}}
							>
								<p className="cursor-pointer">Sort</p>
								<FilterColor className="cursor-pointer" />
							</div>
							{showSort && (
								<div className="absolute top-8 right-0 bg-white shadow-md z-50 w-[170px] rounded-lg p-2">
									<div className="flex flex-col gap-1 w-full">
										{sortOptions?.map((option, index) => (
											<div
												key={index}
												className="flex items-center  w-full justify-between "
											>
												<div
													className=" flex justify-between items-center w-full hover:bg-[#f5f5f5]  p-2 rounded-lg cursor-pointer"
													onClick={() => handleSort(option.name)}
												>
													<p className="text-[14px] font-normal">
														{option.name}
													</p>
													{(option.name === "Price Per Person" ||
														option.name === "Minimum Spend") && (
														<MdChevronRight />
													)}
												</div>{" "}
												{option?.options &&
													showSubSort === "pricePerRoom" &&
													sortType === option.name && (
														<div className="absolute top-0  bg-white shadow-md z-50  rounded-lg right-[175px] w-[160px] p-2">
															<div className="flex flex-col gap-1 w-full">
																{option.options.map((subOption, index) => (
																	<div
																		key={index}
																		className="flex items-center gap-2 cursor-pointer w-full justify-between "
																	>
																		<div
																			className="text-[14px] w-full font-normal cursor-pointer p-2 rounded-lg hover:bg-[#f5f5f5]"
																			onClick={() => handleSubSort(subOption)}
																		>
																			{subOption}
																		</div>
																	</div>
																))}
															</div>
														</div>
													)}
											</div>
										))}
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
				{isShowMap ? (
					<div className={`grid w-full lg:grid-cols-3 gap-6 `}>
						<div
							className={`md:grid w-full lg:col-span-1 lg:grid-cols-1 hidden overflow-y-auto grid-cols-1 gap-6`}
						>
							{isShowMap
								? filterVenues &&
								  filterVenues?.length &&
								  filterVenues?.map((venue, index) => {
										return (
											<VenueStayDetailComponent key={index} data={venue} priority={index < 6} />
										);
								  })
								: venues &&
								  venues.length &&
								  venues?.map((venue, index) => {
										return (
											<VenueStayDetailComponent key={index} data={venue} priority={index < 6} />
										);
								  })}
						</div>
						<div className="lg:col-span-2">
							<div className="relative ">
								<Map
									city={filters?.city ? filters.city : city}
									setIsShowMap={setIsShowMap}
									places={venues}
									setMapBounds={setMapBounds}
									setFilterVenues={setFilterVenues}
								/>
							</div>
							{isMobileView && isShowMap && filterVenues.length > 0 && (
								<div className="absolute top-[54vh] overflow-hidden w-full ">
									<SliderDetailVenueStayTab data={filterVenues} />
								</div>
							)}
						</div>
					</div>
				) : (
					<>
						<div className="grid w-full lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6">
							{venues.map((venue, i) => (
								<VenueStayDetailComponent key={venue._id || i} data={venue} priority={i < 6} breadcrumbPath={breadcrumbPath} />
							))}
						</div>
						<div ref={loadMoreRef} className="h-4" />
						{isFetching && (
							<div className="flex justify-center py-3">
								<div className="w-5 h-5 border-2 border-gray-400 border-t-blue-500 rounded-full animate-spin" />
							</div>
						)}
					</>
				)}

				<BulkEnquiry />
				{bulkEnquiry?.isBulkEnquiryModal && (
					<Modal
						isOpen={bulkEnquiry?.isBulkEnquiryModal}
						onClose={() => dispatch(setBulkEnquiryModal(false))}
					>
						<BulkEnquiryModal
							onClose={() => dispatch(setBulkEnquiryModal(false))}
							selectedEnquiries={bulkEnquiry?.selectedVenues || []}
							enquiryType={bulkEnquiry?.enquiryType || "hotel"}
							isRedirection={false}
						/>
					</Modal>
				)}
			</div>
		</div>
	);
};

export default VenuStayTab;
